export default __webpack_public_path__ + "static/media/TA Logo.361f54c2.png";